'use strict';

  let rangeShow = document.querySelector(".form__number");
  let rangeClock =  document.querySelector('.skillometer__clock');
  let skill =  document.querySelectorAll('.skills__checkbox');
  let form = document.querySelector('.form');

  function rangeChange() {
    let summ = 0;
    let percentSkill = 0;

    for(let i = 0; i < skill.length; i++) {
      if(skill[i].checked) {
        summ++;
      }
    }

    percentSkill = Math.round(summ * 100 / skill.length);
    rangeClock.style.transform = 'rotate(' + (-90 + ((percentSkill * 180) / 100)) + 'deg)';
    rangeShow.value = percentSkill + '%';
  }

	form.addEventListener('change', rangeChange);